import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    const wrapper = event.target.closest("[data-nested-form-wrapper]")
    if (wrapper) {
      const destroyInput = wrapper.querySelector("input[name$='[_destroy]']")
      if (destroyInput) {
        destroyInput.value = "1"
        wrapper.classList.add("hidden")
      }
      if (!destroyInput) {
        wrapper.remove()
      }
    }
  }
}


